import { render, staticRenderFns } from "./NodeMetadata.vue?vue&type=template&id=8b3d42ae&"
import script from "./NodeMetadata.vue?vue&type=script&lang=js&"
export * from "./NodeMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports